import { WireModelDto } from '@treasury/api/channel';
import { FiDate } from '@treasury/domain/dates';
import { camelCaseToTitle } from '@treasury/utils';
import { format } from 'date-fns';

export type WirePaymentViewModel = {
    beneficiaryName: string | undefined;
    debitAccount: string | undefined;
    status: string;
    amount: string;
    paymentDate: string;
    frequencyDisplay: string;
    id: number;
    transactionId: string | undefined;
    wireCompany: string | undefined;
    permissions: string[];
    numberOfApprovalsCompleted: number;
    numberOfApprovalsNeeded: number;
};

export class WirePaymentTableViewModel {
    constructor(dto: WireModelDto) {
        this.beneficiaryName = dto.beneficiary.name;
        this.debitAccount = dto.debitAccount.accountDisplayLabel;
        this.status = dto.status;
        this.amount = dto.amount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        this.paymentDate = dto.frequency.nextPaymentDate
            ? format(new FiDate(dto.frequency.nextPaymentDate).date, 'P')
            : '';
        this.frequencyDisplay = this.paymentDate
            ? `${dto.frequency.type} (${this.paymentDate})`
            : dto.frequency.type;
        this.frequencyType = camelCaseToTitle(dto.frequency.type);
        this.id = dto.id;
        this.transactionId = dto.transactionId;
        this.wireCompany = dto.wireCompany
            ? {
                  name: dto.wireCompany.name,
                  isDliWireCompany: dto.wireCompany.isDliWireCompany,
                  id: dto.wireCompany.id,
                  updatedBy: dto.wireCompany.updatedBy ?? undefined,
                  updatedDate: dto.wireCompany.updatedDate,
              }
            : undefined;
        this.destinationCurrency = dto.destinationCurrency;
        this.wireType = dto.isInternational ? 'International' : 'Domestic';
        this.source = dto.source || '';
        this.createdDate = dto.createdDate ? format(dto.createdDate, 'P') : '';
        this.nextPaymentDate = dto.frequency.nextPaymentDate
            ? format(dto.frequency.nextPaymentDate, 'P')
            : '';
        this.endDate = dto.frequency.endOn ? format(dto.frequency.endOn, 'P') : '';
        this.permissions = dto.permissions?.map(p => p.permission) ?? [];
        this.numberOfApprovalsCompleted = dto.completedApprovalCount ?? 0;
        this.numberOfApprovalsNeeded = dto.numberOfApprovalsNeeded ?? 0;
    }

    public beneficiaryName?: string;

    public debitAccount?: string;

    public status: string;

    public amount: string;

    public paymentDate: string;

    public createdDate: string;

    public nextPaymentDate: string;

    public endDate: string;

    public frequencyDisplay: string;

    public frequencyType: string;

    public id: number;

    public transactionId?: string;

    public wireCompany?: {
        name: string;
        isDliWireCompany: boolean;
        id: number;
        updatedBy: string | undefined;
        updatedDate: string;
    };

    public destinationCurrency: string;

    public wireType: 'International' | 'Domestic';

    public source: string;

    public permissions: string[] = [];

    public numberOfApprovalsCompleted: number;

    public numberOfApprovalsNeeded: number;
}
